import AlignVerticalCenterIcon from '@mui/icons-material/AlignVerticalCenter';
import CachedIcon from '@mui/icons-material/Cached';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import Groups2Icon from '@mui/icons-material/Groups2';
import HistoryIcon from '@mui/icons-material/History';
import ImageIcon from '@mui/icons-material/Image';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import LoopIcon from '@mui/icons-material/Loop';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PeopleIcon from '@mui/icons-material/People';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import ShareIcon from '@mui/icons-material/Share';
import { Box } from '@mui/material';

import { ROUTES } from '../routes/path';
import { RoleEnum } from '../types';

const menuItems = [
  {
    text: 'Dashboard',
    icon: <Box component="img" src={require('../assets/icons/ic_dashboard.svg').default} alt="Dashboard" sx={{ width: 21.5, height: 21.5 }} />,
    requireRole: RoleEnum.Dashboard,
    path: '/',
  },
  {
    text: 'Bảng xếp hạng',
    icon: <LeaderboardIcon height={21.5} />,
    path: '/leaderboards',
    requireRole: RoleEnum.Editor,
    subItems: [
      {
        text: 'BXH người chơi',
        path: ROUTES.LEADER_BOARD_PLAYER.LIST,
        icon: <PeopleIcon />,
      },
      {
        text: 'BXH fanclub',
        path: ROUTES.LEADER_BOARD_FANCLUB.LIST,
        icon: <Groups2Icon />,
      },
    ],
  },
  {
    text: 'Quà tặng',
    icon: <CardGiftcardIcon />,
    path: ROUTES.REWARD.LIST,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Người chơi',
    icon: <Box component="img" src={require('../assets/icons/ic_user.svg').default} alt="User" sx={{ width: 21.5, height: 21.5 }} />,
    path: ROUTES.USER_PROFILE,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Fanclub',
    icon: <Box component="img" src={require('../assets/icons/ic_group.svg').default} alt="Fanclub" sx={{ width: 21.5, height: 21.5 }} />,
    path: ROUTES.FAN_CLUB.LIST,
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Đội bóng',
    icon: <Box component="img" src={require('../assets/icons/ic_team.svg').default} alt="Team" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/teams',
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Giải đấu',
    icon: <Box component="img" src={require('../assets/icons/ic_tournament.svg').default} alt="Tournament" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/tournaments',
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Trận đấu',
    icon: <Box component="img" src={require('../assets/icons/ic_match.svg').default} alt="Matches" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/matches',
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Quiz game',
    icon: <Box component="img" src={require('../assets/icons/ic_quiz_game.svg').default} alt="Quiz" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/games',
    requireRole: RoleEnum.Editor,
  },
  {
    text: 'Cấu hình',
    icon: <PermDataSettingIcon />,
    path: '/config',
    requireRole: RoleEnum.Editor,
    subItems: [
      {
        text: 'Gói cước',
        path: ROUTES.CONFIG.PACKAGE.LIST,
        icon: <PhoneInTalkIcon />,
      },
      {
        text: 'Link chia sẻ',
        path: ROUTES.CONFIG.SHARE_LINK.LIST,
        icon: <ShareIcon />,
      },
      {
        text: 'Ảnh nền',
        path: ROUTES.CONFIG.BACKGROUND.LIST,
        icon: <ImageIcon />,
      },
      {
        text: 'Thể lệ',
        path: ROUTES.CONFIG.RULES.LIST,
        icon: <AlignVerticalCenterIcon />,
      },
    ],
  },
  {
    text: 'Lịch sử',
    icon: <HistoryIcon height={21.5} />,
    path: '/logs',
    requireRole: RoleEnum.Editor,
    subItems: [
      {
        text: 'Lịch sử lượt chơi',
        path: ROUTES.LOG.PLAYER_TURNS,
        icon: <LoopIcon />,
      },
      {
        text: 'Lịch sử nhận thưởng',
        path: ROUTES.LOG.REWARD,
        icon: <CardGiftcardIcon />,
      },
      {
        text: 'Lịch sử chơi quiz',
        path: ROUTES.LOG.QUIZ,
        icon: <LeaderboardIcon />,
      },
      {
        text: 'Lịch sử dự đoán',
        path: ROUTES.LOG.PREDICTION,
        icon: <Box component="img" src={require('../assets/icons/ic_quiz_game.svg').default} alt="Quiz" sx={{ width: 21.5, height: 21.5 }} />,
      },
      {
        text: 'Lịch sử điểm',
        path: ROUTES.LOG.PLAYER_POINT,
        icon: <LocalActivityIcon />,
      },
    ],
  },
  {
    text: 'Cài đặt',
    icon: <Box component="img" src={require('../assets/icons/ic_setting.svg').default} alt="Setting" sx={{ width: 21.5, height: 21.5 }} />,
    path: '/setting',
    requireRole: RoleEnum.Admin,
    subItems: [
      {
        text: 'Cache System',
        path: ROUTES.SETTING.CACHE_SYSTEM,
        icon: <CachedIcon />,
      },
      {
        text: 'Quản lý người dùng',
        path: ROUTES.SETTING.USER_MANAGEMENT,
        icon: <ManageAccountsIcon />,
      },
    ],
  },
];

const SCOPE = {
  ADMIN: RoleEnum.Admin,
  EDITOR: RoleEnum.Editor,
  DASHBOARD: RoleEnum.Dashboard,
};

const ACTION_TYPE = {
  EDIT: 'edit',
  ADD: 'add',
};

export const COMMON = {
  APP_VERSION: '1.0.0',
  LABEL_DATE_FROM: 'Ngày bắt đầu',
  LABEL_DATE_TO: 'Ngày kết thúc',
  FORMAT_DATE: 'dd/MM/yyyy',
  FORMAT_DATE_TIME: 'dd/MM/yyyy, HH:mm:ss',
  FORMAT_ISO_DATE: 'yyyy-MM-dd',

  BTN_SEARCH: 'Tìm kiếm',
  BTN_ADD: 'Thêm mới',
  BTN_DELETE: 'Xoá',
  BTN_CANCEL: 'Huỷ bỏ',
  BTN_UPDATE: 'Cập nhật',
  BTN_CONFIRM_RESULT: 'Xác nhận kết quả',
  BTN_CONFIRM: 'Xác nhận',

  STATE_SUCCESS: 'success',
  STATE_ERROR: 'error',
};

const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export { ACTION_TYPE, menuItems, SCOPE, STATUS };
